<template>
  <md-dialog :md-active.sync="showDialog" :md-fullscreen="false"
             :md-click-outside-to-close="false"
             :md-close-on-esc="false">
    <md-dialog-title>シカクマップのトライアルは終了しました。</md-dialog-title>

    <md-dialog-content>
      <p>
        トライアルをご利用いただき、ありがとうございました。<br>
        継続してご利用を希望される場合は、「<a :href="$router.resolve({name: 'BackendUserContractFlow'}).href">本契約の手続き</a>」へお進みください。<br>
        <br>
        トライアル終了後は予告なくログインできなくなる可能性がありますので、<br>
        取得した登記情報は「<a :href="$router.resolve({name: 'BackendUserRequestHistories'}).href">取得履歴</a>」からダウンロードをしていただきますようお願い申し上げます。
      </p>
      <p class="md-caption">
        ※「<a :href="$router.resolve({name: 'BackendUserContractFlow'}).href">本契約の手続き</a>」を行わない限り、自動で本契約へ移行することはございません。<br>
        ※この画面が表示される限り、いつでも本契約へ進んでいただけます。<br>
      </p>
    </md-dialog-content>

    <div class="md-layout md-gutter">
      <div class="md-layout-item md-layout md-alignment-center-center">
        <to-contract-button :label="'メニューへ'"></to-contract-button>
      </div>
    </div>
  </md-dialog>
</template>

<script>
import ToContractButton from './ToContractButton';

export default {
  name      : 'AnnounceTrialEnded',
  components: {ToContractButton},
  props: {
    showDialog: {
      type   : Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss" scoped>
.md-layout {
  margin-bottom: 15px;
}
</style>
